import { OrderPhaseFooterCommandBase, OrderPhaseService } from '@app/shared/components';
import { finishPhaseFooterRoutes, notificationTopic } from '@app/shared/utils';
import { RunPhaseType, RunSubPhaseType } from 'chronos-core-client';
import { LoadingNotificationService } from 'chronos-shared';
import { finalize } from 'rxjs/operators';

export class NextFinishingSubphaseCommandService implements OrderPhaseFooterCommandBase {
  public enabled = true;
  public buttonText: string;
  public required = false;
  public subPhase: RunSubPhaseType;
  public route: string;

  public loadingTopic = notificationTopic.footerNextFinishPhase;

  constructor(private setupFooterService: OrderPhaseService) {}

  public execute(): void {
    LoadingNotificationService.publish(this.loadingTopic, true);
    this.setupFooterService
      .goToNextSubPhase(this.route, RunPhaseType.Finishing, this.subPhase, finishPhaseFooterRoutes)
      .pipe(
        finalize(() => {
          LoadingNotificationService.publish(this.loadingTopic, false);
        })
      )
      .subscribe();
  }

  public setNavigationParams(subPhase: RunSubPhaseType, route: string): void {
    this.subPhase = subPhase;
    this.route = route;
  }
}
